import BaseApi from 'api/base';
import { camelCaseKeys } from 'utils/normalizeData';
import { CLINICIAN_URL, DEFAULT_PAGINATION_LIMIT } from '../constants';

export default {
  // TODO [WB-3215] Currently used in the usePaginationState custom-hook, and the useDebounce test.
  // Evaluate for removal.
  getPaginatedPatientSearch: async (
    params: IPaginatedParams,
  ): Promise<PatientSearchResultsType> => {
    const qs = new URLSearchParams();
    qs.set('limit', DEFAULT_PAGINATION_LIMIT); // set default limit
    const paramsArray = Object.entries(params);

    paramsArray.forEach(([key, value]) => {
      switch (key) {
        case 'locationId':
          if (value) qs.set('location_id', value);
          break;
        case 'sortProp':
          if (value) qs.set('sortBy', value);
          break;
        case 'sortOrder':
          if (value) qs.set('sort', value);
          break;
        case 'queryString':
          if (value) qs.set('term', value);
          break;
        default:
          qs.set(`${key}`, value);
          break;
      }
    });

    const resp: any = await BaseApi.authRequest(
      `${CLINICIAN_URL()}/patient-search?${qs.toString()}`,
      {
        method: 'GET',
      },
    );

    return camelCaseKeys(resp);
  },
};

export interface IPatientSearchParams {
  limit?: string;
  locationId: string;
  nextCursor?: string;
  prevCursor?: string;
  queryString?: string;
  sortOrder?: string;
  sortProp?: string;
}

export type PatientSearchResultsType = {
  meta: IPaginationMeta;
  data: IFormattedPatientSearchData[];
};

// TODO (MW) is this still needed?...
export interface IPaginatedParams {
  limit?: string;
  prevCursor?: string;
  nextCursor?: string;
  sort?: string;
  sortBy?: string;
  attritubutes?: string;
  term?: string;
  locationId: string;
}
